/*
 * @Author: jiaqian@didiglobal.com
 * @Date: 2020-09-25 22:03:00
 * @Last Modified by: wangqingran
 * @Last Modified time: 2020-11-12 20:04:12
 * @Description: 手机号+区号组件
 */
 <template>
  <section class="phone-validate">
     <rich-input
      v-model="tel.number"
      :placeholder="$t('FoodC_2_Enter_mobile_jXbU')"
      type="tel"
      :readonly="false"
      :autofocus="true"
      :clearable="true"
      :maxlength="tel.max"
      :error="errorMessage?errorMessage:''"
    >
      <p
        class="country-code"
        slot="prepend"
        @click="showPicker"
      >
        <span>{{selectedValue.calling_code}}</span>
        <img
          src="https://img0.didiglobal.com/static/soda_static/m/act/static/img/icon_quhao_down.png"
          alt=""
          srcset=""
        >
      </p>
    </rich-input>
    <!-- <p class="validate-error" v-if="errorMessage">{{errorMessage}}</p> -->
    <slot></slot>
    <rich-button
      class="validate-button"
      :loading="loading"
      @click="handleClick"
    >
    {{buttonText}}
    </rich-button>
  </section>
</template>
<script>
import Vue from 'vue'
import API from '@/api'
import getCountryConfig from '@/common/config/country-config'
import { Picker, Locale } from '@didi/rich-ui'
import { getLanguageLong } from '@didi/gettext'
Vue.use(Picker)
Vue.use(Locale)
const currentLang = getLanguageLong()
Locale.use(currentLang, require(`@didi/rich-ui/lib/locale/lang/${currentLang}`))

export default {
  name: 'TelValidate',
  props: {
    value: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      max: 10,
      list: [],
      selectedValue: {max_len: 20, calling_code: '+52'},
      countryList: [],
      tel: {
        number: '',
        max: 20,
        min: 1,
        code: '+52'
      },
      errorMsg: '',
      radioOption: ''
    }
  },
  mounted () {
    this.getData()
  },
  watch: {
    value: function (val) {
      this.tel.number = val
    }
  },
  computed: {
    country () {
      return this.$store.state.country
    }
  },
  methods: {
    async getData () {
      this.countryList = await API.getCountryList()
      this.countryList.data.data.data.forEach((item, index) => {
        let obj = {value: item.calling_code, text: `${item.name}(${item.calling_code})`}
        if (item.area === this.country) {
          this.selectHandle(item, index)
        }
        this.list.push(obj)
      })
    },
    handleClick () {
      this.$emit('confirm', this.tel)
    },
    showPicker () {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: this.gettext('选择国家或地区'),
          data: [this.list],
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    selectHandle (selectedVal, selectedIndex, selectedText) {
      this.selectedValue = this.countryList.data.data.data[selectedIndex]
      this.tel.max = this.selectedValue.max_len
      this.tel.min = this.selectedValue.min_len
      this.tel.code = this.selectedValue.calling_code
    },
    handleJump () {
      // 跳转用户协议链接
      location.href = getCountryConfig.middleLink.TC_PROTOCOL_URL(this.country)
    }
  }
}
</script>
<style lang="stylus">
@import "~@/common/stylus/base"
@import "~@/common/stylus/mixin"
@import "~@/common/stylus/main"
@import "~@/common/stylus/variables"
.phone-validate {
  .rich-input {
    justify-content: center;
    border-bottom: 2px solid #EDEDEE;
    line-height 43px
    caret-color #FF6325
    .rich-input-field {
      font-family: 'Aspira Regular';
      font-size: 36px;
      color: #000000;
      // text-indent: 17px;
      padding: 20px 27px;
      margin-left: 0;
    }
    .rich-input-field::-webkit-input-placeholder {
      font-size: 36px;
      padding-top: 10px;
      font-weight: normal;
    }
    .richic-wrong {
      &::before {
        opacity 0.15
        color #000000
      }
    }
  }
  @supports (-webkit-mask: none) and (not (cater-color: red)) {
    .rich-input::first-line { color: #FF6325; }
  }
  .rich-input:after {
    border:none;
  }
  .country-code {
    background #EEEEEE
    border-radius 4px
    font-family 'Aspira Regular'
    font-size 32px
    color #666666
  }
  .rich-input-prepend {
    z-index: 100;
    background-color: #EEEEEE;
    border-radius: 4px;
    text-align: center;
    p {
      width: 122px;
      padding: 0 38px 0 18px;
      line-height 56px;
      box-sizing border-box
      position: relative;
      font-size: 32px;
      color: #666;
      display: flex;
      font-family 'Aspira Regular'
      align-items: center;
      justify-content: center;
      img {
        position: absolute;
        top: 50%;
        margin-top: -4px;
        right: 18px;
        width 11px;
        height 7px;
        margin-left 8px;
        margin-bottom 4px;
      }
    }
  }
  // .validate-error {
  //   font-size: 14px;
  //   color: #FF5B1D;
  //   height: 20px;
  //   line-height: 1;
  //   margin-top: 10px;
  // }
  .validate-button {
    margin 0 auto
    width: 400px
  }
  .user-protocal {
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 10px;
    padding-left: 64px;
    &-title {
      text-align: left;
      font-size: 28px;
      line-height: 32px;
      font-family: 'Aspira Regular'
      span {
        font-family: 'Aspira Regular'
        &.link {
          font-color()
          cursor: pointer;
        }
      }
    }
    .radio-protocal {
      position: absolute;
      top: 50%;
      margin-top: -20px;
      left: 0;
    }
    .radio {
      width: 40px
      height: 40px
      input {
        &.radio-input {
          width: 40px
          height: 40px
          display: none
        }
        &:checked {
          & + label {
            border: 0;
            new-coupon-check-label-bg()
          }
        }
      }
      .radio-label {
        width: 40px
        height: 40px
        box-sizing: border-box
        display: inline-block
        border-radius: 50%
        background: #FFFFFF
        background-size: auto 100%
        border: 2px solid #CCCCCC
      }
    }
  }
  >>> .rich-toast .rich-popup-content .rich-toast-tip {
    max-height: none;
  }
  .rich-popup {
    /deep/ .rich-popup-container {
      position: fixed
    }
  }
}
.rich-popup {
  /deep/ .rich-popup-container {
    position: fixed
  }
  /deep/ .rich-picker-cancel{
    line-height :112px!important
  }
}

</style>
